import { render, staticRenderFns } from "./AutoTool.vue?vue&type=template&id=9fc4dd64&scoped=true"
import script from "./AutoTool.vue?vue&type=script&lang=js"
export * from "./AutoTool.vue?vue&type=script&lang=js"
import style0 from "./AutoTool.vue?vue&type=style&index=0&id=9fc4dd64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc4dd64",
  null
  
)

export default component.exports